module.exports = __webpack_public_path__ + "static/media/Cats eyes 02_FRANSKA-mixdown.fb4cf7cd.mp3";